import { useId, type ChangeEvent, type ReactNode } from 'react';

type PermissionGroupToggleProps = {
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  title: ReactNode;
  helperText?: ReactNode;
  id?: string;
  disabled?: boolean;
};

export default function PermissionGroupToggle({
  checked,
  onChange,
  title,
  helperText,
  disabled,
  id,
}: PermissionGroupToggleProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const label = title ?? helperText ?? 'Alternar permissão';
  return (
    <div className="d-flex justify-content-between gap-4">
      <div className="d-flex flex-column justify-content-center">
        <label className="fw-bold text-gray-700 fs-6" htmlFor={inputId}>
          {label}
        </label>
        {helperText ? <span className="text-gray-500 fs-7">{helperText}</span> : null}
      </div>
      <div className="form-check form-switch form-check-custom form-check-solid">
        <input
          checked={checked}
          className="form-check-input"
          disabled={disabled}
          id={inputId}
          type="checkbox"
          onChange={onChange}
        />
        <span className="form-check-label">{checked ? 'Ativado' : 'Desativado'}</span>
      </div>
    </div>
  );
}
